<div *ngIf="errors?.length" class="errors ion-text-left">
  <div class="error-wrap">
    <ul>
      <li *ngFor="let error of errors">
        <ion-text color="danger">{{error}}</ion-text>
      </li>
    </ul>
  </div>
</div>
